import React from 'react';

import JumbotronFullBleedCta from 'components/ModularBlocks/FullBleedCta/components/Jumbotron';
import StandardFullbleedCta from 'components/ModularBlocks/FullBleedCta/components/StandardFullbleedCta';

import { FullBleedCtaI } from 'interfaces/content-stack/modular-blocks/fullBleedCta';

export interface FullBleedCtaProps {
  data: FullBleedCtaI;
  className?: string;
}

const FullBleedCta = ({ data, className }: FullBleedCtaProps) => {
  const { fullBleedOptions } = data;

  return (
    <div className={className}>
      {fullBleedOptions.map((fullBleedOption, i) => {
        if (fullBleedOption.jumbotron) {
          return <JumbotronFullBleedCta key={i} {...fullBleedOption.jumbotron} />;
        } else if (fullBleedOption.standard) {
          return <StandardFullbleedCta key={i} {...fullBleedOption.standard} />;
        } else return null;
      })}
    </div>
  );
};

export default FullBleedCta;
